import { Check } from "@mui/icons-material";
import { Button, Card, CardContent, Container, Divider, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { setBreadcumbs } from "../../../../containers/containers.reducer";
import FormAutocomplete from "../../../../shared/FormAutocomplete";
import FormDate from "../../../../shared/FormDate";
import FormNumber from "../../../../shared/FormNumber";
import FormText from "../../../../shared/FormText";
import notificationError from "../../../../shared/notificationError";
import notificationSuccess from "../../../../shared/notificationSuccess";
import { createJobActivity, getJobSingle } from "../../project.api";

export default function JobNumberJobAddActivity() {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()

    const [values, setValues] = useState<any>({
        koj_id: "",
        source_job: "",
        quantity_request: 0

    })
    const [jobData, setJobData] = useState<any>({})

    useEffect(() => {
        dispatch(setBreadcumbs([
            {
                name: "Project",
                url: "/project"
            },
            {
                name: "Details",
                url: ""
            },
            {
                name: "Job",
                url: ""
            },
            {
                name: "Add Activity",
                url: "/project/detail/job/addactivity"
            }
        ]))
        let jobId = searchParams.get('jobid')
        dispatch<any>(getJobSingle(jobId))
            .unwrap()
            .then((response: any) => {
                if (response.status === 200) {
                    setJobData(response.data.data)
                }
                else {
                    notificationError(response)
                }
            })
    }, [])

    const handleChangeValues = (e: any) => {
        const { name, value } = e.target
        setValues({
            ...values,
            [name]: value
        })
    }

    const handleSubmit = (e: any) => {
        e.preventDefault()
        let dataToPost = {
            previous_id: searchParams.get('jobid'),
            source_job: values.source_job,
            quantity_request: values.quantity_request,
            koj_id: values.koj_id
        }
        console.log(dataToPost)
        dispatch<any>(createJobActivity(dataToPost))
            .unwrap()
            .then((response: any) => {
                if (response.status === 200) {
                    notificationSuccess("success create new request job")
                        .then(() => {
                            navigate(-1)
                        })
                }
                else {
                    notificationError(response)
                }
            })
    }

    return (
        <Container maxWidth="xl">
            <Card>
                <CardContent className="custom-form">
                    <form onSubmit={handleSubmit}>
                        <div className="form-header">
                            <span>
                                Add Activity
                            </span>
                            <div>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => navigate(-1)}
                                >
                                    Discard
                                </Button>
                                <Button
                                    variant="contained"
                                    startIcon={<Check />}
                                    type="submit"
                                >
                                    Add Activity
                                </Button>
                            </div>
                        </div>
                        <br />
                        <Divider />
                        <Grid container spacing={2}>
                            <Grid item md={5}>
                                <br />
                                <FormText label="Order Number" value={jobData.jobnumber_number_order} disabled />
                                <br />
                                <FormText label="Team" value={jobData.jobnumber_project_team_name} disabled />
                                <br />
                                <FormText label="Job Number" value={jobData.jobnumber_number_job} disabled />
                                <br />
                                <FormText label="Requestor" value={jobData.jobnumber_project_requestor_name} disabled />
                                <br />
                                <FormText label="Submittal" value={jobData.jobnumber_project_submittal_name} disabled />
                                <br />
                                <FormText label="District" value={jobData.jobnumber_project_district_name} disabled />
                                <br />
                            </Grid>
                            <Grid item md={1}></Grid>
                            <Grid item md={6}>
                                <br />
                                <FormText label="Project" value={jobData.jobnumber_project_name} disabled />
                                <br />
                                <FormAutocomplete label="KOJ" url="/koj" name="koj_id" value={values.koj_id} onChange={handleChangeValues} />
                                <br />
                                <FormDate label="Job Received" value={jobData.jobnumber_date_received ? jobData.jobnumber_date_received.split('T')[0] : ""} disabled />
                                <br />
                                <FormDate label="Due Date" value={jobData.jobnumber_date_due ? jobData.jobnumber_date_due.split('T')[0] : ""} disabled />
                                <br />
                                <FormText label="Source Job" name="source_job" value={values.source_job} onChange={handleChangeValues} />
                                <br />
                                <FormNumber label="QTY Request" name="quantity_request" value={values.quantity_request} onChange={handleChangeValues} />
                                <br />
                            </Grid>
                        </Grid>
                    </form>
                </CardContent>
            </Card>
        </Container>
    )
}